<template>
  <table class="codeTable text-black">
    <thead>
      <tr>
        <th v-for="letter in code" :key="letter" class="codeLetter">
          {{ letter }}
        </th>
      </tr>
    </thead>
  </table>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      required: true
    }
  }
}
</script>
